import { formatDistanceToNow, parseISO } from 'date-fns';

// Notification structure
export interface Notification {
  id: string;
  title: string;
  message: string;
  type: 'info' | 'success' | 'warning' | 'alert';
  timestamp: string; // ISO date string
  read: boolean;
  link?: string; // Optional link to navigate to
}

// Mock notification data - will be replaced with real API later
export const mockNotifications: Notification[] = [
  {
    id: '1',
    title: 'Course Assignment',
    message: 'You have been assigned to "React Fundamentals"',
    type: 'info',
    timestamp: new Date(Date.now() - 1000 * 60 * 30).toISOString(), // 30 min ago
    read: false,
    link: '/all-courses',
  },
  {
    id: '2',
    title: 'Team Update',
    message: 'John Smith completed "TypeScript Basics"',
    type: 'success',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(), // 2 hours ago
    read: false,
    link: '/my-team',
  },
  {
    id: '3',
    title: 'Deadline Reminder',
    message: 'Course "Advanced JavaScript" due in 3 days',
    type: 'warning',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 5).toISOString(), // 5 hours ago
    read: false,
    link: '/my-progress',
  },
  {
    id: '4',
    title: 'Certification Available',
    message: 'You are now eligible for React certification',
    type: 'success',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString(), // 1 day ago
    read: true,
    link: '/certification-courses',
  },
  {
    id: '5',
    title: 'Payment Due',
    message: 'Your subscription payment is due soon',
    type: 'alert',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2).toISOString(), // 2 days ago
    read: true,
    link: '/billing',
  },
];

// Format timestamp to relative time using date-fns
export function formatNotificationTime(isoDate: string): string {
  return formatDistanceToNow(parseISO(isoDate), { addSuffix: true });
}

// Get unread notification count
export function getUnreadCount(notifications: Notification[]): number {
  return notifications.filter(n => !n.read).length;
}

